import Breadrcumbs from "../internal/Breadcrumbs";
import React, {useEffect} from "react";
import {transformImage} from "../../utils/StoryblokService";
import Head from "next/head";
import {useRouter} from "next/router";
import {SbBlokData} from "@storyblok/react";

interface NavigationItem {
    name: string,
    link: any,
    icon: string
}

export default function Breadcrumbs(props: { blok: { items: NavigationItem[], wrapper_class: string, container_size: string } & SbBlokData }) {
    const pageItems = props.blok.items;
    const router = useRouter()
    const [pages, setPages] = React.useState<any[]>([]);

    useEffect(() => {
        const tempPages: any[] = []

        pageItems.map((item: NavigationItem, x: number) => {
                const thisSite = (typeof window !== 'undefined') ? window.location.pathname : '';

                tempPages.push({
                    name: item.name,
                    href: (x == props.blok.items.length - 1) ? thisSite : item.link.cached_url,
                    current: false
                })
            }
        )

        setPages(tempPages)

        return () => {
            setPages([])
        }
    }, [router.isReady])


    return <>

        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(
                        {
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            "itemListElement": pages.map((item: any, x: number) => {
                                return {
                                    "@type": "ListItem",
                                    "position": x + 1,
                                    "name": item.name,
                                    "item": item.href
                                }
                            })
                        }
                    )
                }}/>

        </Head>

        {pages.length > 0 &&
            <div className={props.blok.wrapper_class}>
                <div className={props.blok.container_size + ' px-4 sm:px-6 lg:px-8 mx-auto '}>
                    <Breadrcumbs pages={pages}/>
                </div>
            </div>}
    </>
}